module.exports = __webpack_public_path__ + "img/card.f13cd7b4.svg";